// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3yHsm","title":"Images90_title__1gao4","images":"Images90_images__3fAmc"};